/**
 * Custom hook to handle event cancellation functionality.
 *
 * This hook manages the state of the event cancellation dialog and form validation.
 * It provides form handling using Formik with validation through Yup schema.
 *
 * @returns {Object} An object containing all the required properties and methods for event cancellation.
 */

import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

export default function useCancelEvent() {
    const [openEventCancelDialog, setOpenEventCancelDialog] = React.useState(false);

    const initialValues = {
        reason: ''
    };

    const validationSchema = Yup.object().shape({
        reason: Yup.string().required('Reason for cancellation is required')
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values) => {
            console.log('Event Cancelled :', values);
        }
    });

    return {
        formik,
        openEventCancelDialog,
        setOpenEventCancelDialog
    };
}
